import React, { Dispatch, SetStateAction } from 'react';
import group from "../assets/images/Rectangle 18156.png";
import user from "../assets/images/user.png";
import DotMenu from './DotMenu';
import { CalendarIcon, CalendarThreePartIcon, EditIcon, TranslateIcon, TrashIcon } from '../assets/icons/Icons';

interface FileCardProps {
  width?: string;
  className?: string;
  setSelected?: Dispatch<SetStateAction<string>>;
}

const options = [
  { label: 'Schedule a post', icon: CalendarIcon },
  { label: 'Edit details', icon: EditIcon },
  { label: 'Delete file', icon: TrashIcon, color: "red" },
];

const FileCard: React.FC<FileCardProps> = ({ width, className, setSelected}) => {
  return (
    <div onClick={() => setSelected && setSelected("1")} className={`${width ? `w-[${width}]` : "w-[379px]"} h-[110px] rounded-xl bg-white flex items-center gap-2 ${className} cursor-pointer`}>
      <img src={group} className="w-[93px] h-[102px] m-1 inline-block" alt="group" />
      <div className="w-full py-3 pr-3">
        <div className="flex justify-between">
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">Game video</p>
          <DotMenu options={options} setSelected={setSelected} type="normal" md />
        </div>
        <div className="flex items-center gap-[6px] mt-[6px]">
          <img src={user} className="w-4 h-4 rounded-full" alt="user" />
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Andrew Wack</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <TranslateIcon />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Languages</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">English</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <CalendarThreePartIcon />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Video lengths</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">15:23</p>
        </div>  
      </div>
    </div>
  );
};

export default FileCard;